import React, { useEffect, useLayoutEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CommonToolTip, CstmPagination } from "../../../../components/Common/Common";
import { Link, useNavigate } from "react-router-dom";
import TableHeader from "components/shared/FormComponents/TableHeader";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useDeleteFundingSourceMutation, useFundingSourceListQuery, useUpdateFundingSourceMutation } from "store/services/fundingSource";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import { successMessageToast, userFullName } from "helpers/common";
import { ArchiveIcon, DeleteIcon, EditIcon, UnArchiveIcon } from "Assets/icons";
import { EDIT_FUNDING_SOURCE } from "config/paths";
import { useDispatch, useSelector } from "react-redux";
import { fundingSourceFilter } from "store/slices/filter";

const PCFundingSource = () => {

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const filter = useSelector(state => state?.filter?.fundingSourceFilter);

  const [modalType, setModalType] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentEntry, setCurrentEntry] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const [updateClient, { isLoading: updateClientLoading }] = useUpdateFundingSourceMutation();
  const [deleteClient, { isLoading: deleteClientLoading }] = useDeleteFundingSourceMutation();
  const { data, isLoading, isError, isFetching } = useFundingSourceListQuery({ page: currentPage, limit: pageSize, ...filter });

  const [fundingSourceList, setFundingSourceList] = useState(data?.records || []);
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const resetFilter = () => {
    dispatch(fundingSourceFilter({  search: "", status: "active", sort: { column: "name", direction: "asc" } }));
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    dispatch(fundingSourceFilter({ ...filter, [key]: value }))
    setCurrentPage(1); // Reset to first page when filter changes
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const handleDelete = async () => {
    try {

      setShowModal(false);

      const list = [...fundingSourceList];
      const index = fundingSourceList?.findIndex(x => x.id === currentEntry?.id);
      delete list[index];
      setFundingSourceList(list.filter(Boolean));

      const result = await deleteClient(currentEntry?.id);
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("Error deleting funding source", err);
    };
  };

  const handlArchive = async () => {

    try {

      setShowModal(false);

      const list = [...fundingSourceList];
      const index = fundingSourceList?.findIndex(x => x.id === currentEntry?.id);
      list[index] = { ...list[index], status: list[index].status == "active" ? "archived" : "active" };
      setFundingSourceList(list.filter(Boolean));

      const data = {
        name: currentEntry.name,
        description: currentEntry.description,
        status: currentEntry.status == "active" ? "archived" : "active",
      };

      const result = await updateClient({ data, fundingSourceId: currentEntry.id });
      if (!result?.error) successMessageToast(result?.data?.message);

    } catch (err) {
      console.error("error Archive funding source", err);
    };
  };

  const handleDeleteClick = (item) => (event) => {

    event.stopPropagation();
    setCurrentEntry(item);
    setModalType("delete");
    setShowModal(true);
  };

  const handleEditClick = (item) => (event) => {

    event.stopPropagation();
    navigate(EDIT_FUNDING_SOURCE.replace(":id", item.id));
  };

  const handleArchiveClick = (item) => (event) => {

    event.stopPropagation();
    setModalType(item?.status == "active" ? "archive" : "active");
    setCurrentEntry(item);
    setShowModal(true);
  };

  const column = [
    {
      head: "Name",
      accessor: "name",
      isComponent: true,
      sorter: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-sbold">{item.name}</h6>
      ),
    },
    // {
    //   head: "Contact Person",
    //   accessor: "FirstName",
    //   isComponent: true,
    //   component: (item, ind) => (
    //     <h6 className="m-0 fw-sbold">{item.contact_title + " " + userFullName({ firstname: item.contact_first_name, lastname: item.contact_last_name })}</h6>
    //   ),
    // },
    // {
    //   head: "Contact",
    //   accessor: "phone_number",
    // },
    // {
    //   head: "Email",
    //   accessor: "email",
    // },
    {
      head: "Status",
      accessor: "status",
      sorter: true,
      isComponent: true,
      component: (item, ind) => (
        <p
          style={{ width: 80 }}
          className={`${item.status == "active"
            ? "greenStatus"
            : "redStatus"
            } status fw-bold text-capitalize m-0 text-center d-flex align-items-center justify-content-center rounded-pill px-4 py-1`}
        >
          {item.status}
        </p>
      ),
    },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          <CommonToolTip
            text={"Edit"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={handleEditClick(item)}
            >
              <EditIcon />
            </Button>}
          />
          <CommonToolTip
            text={item?.status == "active" ? "Archive" : "Unarchive"}
            component={<Button
              onClick={handleArchiveClick(item)}
              className="p-0"
              variant="transparent"
              type="button"
            >
              {item?.status == "active" ? <ArchiveIcon /> : <UnArchiveIcon />}
            </Button>}
          />
          <CommonToolTip
            text={"Delete"}
            component={<Button
              className="p-0"
              variant="transparent"
              type="button"
              onClick={handleDeleteClick(item)}
            >
              <DeleteIcon />
            </Button>}
          />
        </div>
      ),
    },
  ];

  useLayoutEffect(() => {

    if (data?.records) setFundingSourceList(data?.records)
  }, [data]);

  return (
    <>
      <ConfirmationPop
        confirmation={showModal}
        setConfirmation={setShowModal}
        confirmHandler={modalType == "delete" ? handleDelete : handlArchive}
        type={modalType}
      />
      <section className="client position-relative py-4">
        <Container fluid={true}>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading={"Funding Sources"}
                    handleFilterChange={handleFilterChange}
                    resetFilter={resetFilter}
                    filter={filter}
                    searchPlaceholder="Name"
                  />
                </div>
                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                    <li className="">
                      <Link
                        to="/manage-private-clients/funding-sources/add"
                        className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                      >
                        <span className="icn me-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19"
                            height="19"
                            viewBox="0 0 19 19"
                            fill="none"
                          >
                            <mask
                              id="mask0_0_4440"
                              style={{ maskType: "alpha" }}
                              maskUnits="userSpaceOnUse"
                              x="0"
                              y="0"
                              width="19"
                              height="19"
                            >
                              <rect
                                width="18.7197"
                                height="18.7197"
                                fill="#D9D9D9"
                              />
                            </mask>
                            <g mask="url(#mask0_0_4440)">
                              <path
                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                fill="white"
                              />
                            </g>
                          </svg>
                        </span>{" "}
                        Add Funding Source
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching || deleteClientLoading || updateClientLoading) && <LoadingOverlay />}
                    <TableLayout
                      data={fundingSourceList}
                      column={column}
                      filter={filter}
                      handleSort={handleFilterChange("sort")}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default PCFundingSource;
